/* eslint-disable @typescript-eslint/no-unsafe-argument, max-params */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines, complexity, @typescript-eslint/no-unsafe-call */
/* eslint-disable no-unused-vars, @typescript-eslint/no-unsafe-member-access  */
/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment  */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
//  also, react class components.

import React, { Component } from 'react';
import { AlertsDetail } from '@elliemae/ds-icons';
import { DSTooltipV3 } from '@elliemae/ds-tooltip';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { styled } from '@elliemae/ds-system';
import { resolveDependencies } from '../helpers/dependencies.js';
import ConditionController from '../ConditionController/ConditionController.js';
import DragControllerRow from '../DragControllerRow/DragControllerRow.js';

const StyledDiv = styled.div`
  .em-ds-query-builder-row__input-controller {
    padding-top: 0.1538rem; // 2px converted to rem based on 1rem = 13px
  }
`;

const RenderField = ({
  target,
  component,
  valueProp,
  additionalInfo,
  handleMouseEnterInput,
  handleMouseLeaveInput,
  onChangeHandler,
  hasError,
}) => {
  const ref = React.useRef<HTMLElement>();
  const id = React.useMemo(() => `el_${String.fromCharCode(65 + Math.floor(Math.random() * 26))}`, []);
  const UserComponent = component;
  const componentNewProps = {
    id,
    onChange: (e, extraData) => onChangeHandler(e, target, extraData),
    value: valueProp != null ? valueProp : '',
    checked: valueProp === true,
    additionalInfo: additionalInfo ? additionalInfo[target] : additionalInfo || {},
    'aria-invalid': Boolean(hasError),
  };

  return (
    <StyledDiv
      className={`em-ds-query-builder-row-input child-type-${target} ${
        hasError && hasError.error ? 'row-input-error' : ''
      }`}
      onMouseDownCapture={() => {
        // eslint-disable-next-line no-underscore-dangle
        const refInput = ref.current?.querySelector(`#${id}`);
        // eslint-disable-next-line @typescript-eslint/no-implied-eval
        if (refInput && refInput.focus) setTimeout(refInput.focus());
        handleMouseEnterInput();
      }}
      onMouseEnter={() => handleMouseEnterInput()}
      onMouseLeave={() => handleMouseLeaveInput()}
    >
      <div ref={ref} className="em-ds-query-builder-row__input-controller">
        {React.isValidElement(UserComponent) ? (
          React.cloneElement(UserComponent, componentNewProps)
        ) : (
          <UserComponent {...componentNewProps} />
        )}
      </div>
      {hasError && hasError.errorMessage ? (
        <div style={{ width: '40px' }}>
          <DSTooltipV3 text={hasError.errorMessage}>
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
            <div tabIndex={0} className="row-icon-alert" data-testid="qb-error-state-icon" role="alert">
              <AlertsDetail width={20} height={20} color={['danger', 900]} title={hasError.errorMessage} />
            </div>
          </DSTooltipV3>
        </div>
      ) : null}
    </StyledDiv>
  );
  // return React.useMemo(
  //   () => (
  //     <div
  //       className={`em-ds-query-builder-row-input child-type-${target}`}
  //       onMouseDownCapture={() => {
  //         // eslint-disable-next-line no-underscore-dangle
  //         const _refInput = ref.current.querySelector(`#${id}`);
  //         if (_refInput && _refInput.focus) setTimeout(_refInput.focus());
  //         handleMouseEnterInput();
  //       }}
  //       onMouseEnter={() => handleMouseEnterInput()}
  //       onMouseLeave={() => handleMouseLeaveInput()}
  //     >
  //       <div ref={ref} className="em-ds-query-builder-row__input-controller">
  //         {React.cloneElement(component, {
  //           id,
  //           onChange: (e, extraData) => onChangeHandler(e, target, extraData),
  //           value: valueProp != null ? valueProp : '',
  //           checked: valueProp === true,
  //           additionalInfo: additionalInfo ? additionalInfo[target] : {},
  //         })}
  //       </div>
  //     </div>
  //   ),
  //   [target, component, valueProp, additionalInfo],
  // );
};
class QueryBuilderRow extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(e, target, extraData, hasError) {
    const { handleFieldChange, idFilter, idGroup, additionalInfo, field, operator, value } = this.props;
    let eventValue = e;
    if (e && e.target) {
      const { value: targetValue, checked } = e.target;
      if (targetValue || targetValue === '' || typeof targetValue === 'boolean') eventValue = targetValue;
      else eventValue = checked || e;
    }
    handleFieldChange({
      [target]: eventValue,
      idFilter,
      idGroup,
      additionalInfo: {
        ...additionalInfo,
        [target]: extraData,
        [`${target}_error`]: hasError,
        [`${target}_touched`]: true,
      },
      target,
    });
  }

  handleMouseEnterRow = () => {};

  handleMouseLeaveRow = () => {
    this.handleTooltipRow(false);
  };

  handleMouseEnterInput = () => {
    const { setDraggableItems } = this.props;
    setDraggableItems(false);
  };

  handleMouseLeaveInput = () => {
    const { setDraggableItems } = this.props;
    setDraggableItems(true);
  };

  handleTooltipRow = (isOpen) => {
    this.setState({ isOpen });
  };

  render() {
    const { isOpen } = this.state;
    const {
      fields,
      onAddFilter,
      onRemoveFilter,
      onAddRuleContainer,
      field,
      operator,
      value,
      additionalInfo,
      items,
      singleRow,
      toolTipZIndex,
      error,
    } = this.props;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { cssClassName, classNameBlock, classNameElement } = convertPropToCssClassName(
      'query-builder-row',
      isOpen ? 'has-open-tooltip' : 'has-close-tooltip',
      singleRow ? 'is-single-row' : 'is-multiple-row',
    );
    const test = resolveDependencies(
      {
        field,
        operator,
        value,
        additionalInfo,
      },
      fields,
    );

    const gridTemplateColumns = [
      singleRow ? '' : '24px',
      ...test.map((r) => {
        if (r.handleWidth) {
          return r.handleWidth(this.props[r.target], {
            field,
            operator,
            value,
            additionalInfo,
          });
        }
        return 'minmax(0, 1fr)';
      }),
      '30px',
    ].join(' ');

    return (
      <div
        className={cssClassName}
        onMouseEnter={this.handleMouseEnterRow}
        onMouseLeave={this.handleMouseLeaveRow}
        style={{
          gridTemplateColumns,
        }}
      >
        {!singleRow && (
          <DragControllerRow
            className={classNameElement('drag-controller')}
            onMouseDownCapture={() => this.handleMouseLeaveInput()}
          />
        )}
        {test.map((renderField) => {
          const { target, component } = renderField;
          const { [target]: valueProp } = this.props;

          const isTouched = additionalInfo && additionalInfo[`${target}_touched`];
          const hasError =
            renderField && renderField.validation
              ? renderField.validation(valueProp, {
                  field,
                  operator,
                  value,
                  additionalInfo,
                })
              : false;
          return (
            <RenderField
              component={component}
              target={target}
              valueProp={valueProp}
              onChangeHandler={(e, changeTarget, extraData) => {
                this.onChangeHandler(e, changeTarget, extraData, hasError);
              }}
              handleMouseEnterInput={this.handleMouseEnterInput}
              handleMouseLeaveInput={this.handleMouseLeaveInput}
              additionalInfo={additionalInfo}
              hasError={isTouched && hasError}
            />
          );
        })}
        {!singleRow && (
          <div className={classNameBlock('controller')}>
            <ConditionController
              handleTooltipRow={this.handleTooltipRow}
              isOpen={isOpen}
              items={items}
              onAddFilter={onAddFilter}
              onAddRuleContainer={onAddRuleContainer}
              onRemoveFilter={onRemoveFilter}
              toolTipZIndex={toolTipZIndex}
            />
          </div>
        )}
      </div>
    );
  }
}

export default QueryBuilderRow;
